export const isKPMGAU = (templateKey: string) => templateKey.includes("_au_");
export const isKPMGCA = (templateKey: string) => templateKey.includes("_ca_");

export const getKPMGClientsFieldNames = (templateKey: string) => [
  isKPMGCA(templateKey) ? "brands" : "clients"
];

export const isKPMGCAFrench = (templateKey: string) => templateKey.includes("_ca_french");

export const getKPMGQualificationsFieldNames = (templateKey: string) =>
  isKPMGCA(templateKey)
    ? ["major", "degree", "licenses_certifications"]
    : ["certificates", "qualifications", "licenses_and_certifications"];
